<template>
    <div class="login px-1 pt-5">
        <p v-if="loading">verifying token</p>
         <!-- {{ isLoggedIn }} -->
         <p class="text-success">{{ message }}</p>
        <p class="text-danger" v-if="error">{{ error }}</p>

    </div>
</template>
<script>
export default {
    name: 'request_token',
    data(){
        return {
            message: '',
            loading: true,
            error: null
        }
    },
    computed: {
        isLoggedIn: () => {
          return this.$store.getters.isLoggedIn;
        }
    },
    mounted: function (){
                const data = { token: this.$route.query.token }
                // console.log(data)

                this.$store.dispatch("verifyToken", data)
                    .then(resp => {
                        this.loading = false;
                        // console.log(resp, resp.headers)
                        this.message = resp.data;
                        this.$router.push('/login')
                    })
                    .catch(err => {
                        this.loading = false;
                        // console.log("got error "+err)
                        this.error = err.message;
                    })

    }
}

</script>
<style scoped>

.input-title{
    margin-left:25px;
    font-size: 13px;
}

.logo-size{
    height: 45px;
    width: 150px;
}

.kovatek-login{
  width:600px;
} 
.add-grey{
    background-color:#ddd;
}
.add-grey:hover{
    background-color:#ccc;
}
.input-height{
    height: 50px;
    font-size: 13px;
    width: 100%;
}

.btn-kovatek{
  background-color: #20409A;
  height: 50px;
  color: #fff;
  transition: .25s;
}
.btn-kovatek:hover{
  background-color: #06216d;
  color: #fff;
}
.icon-size{
    font-size: 20px;
}

@media (min-width: 768px) and (max-width: 991px){
  
}
@media (max-width: 767px){
.kovatek-login{
  width:400px;
} 
.input-height{
    font-size: 16px;
}
}

@media (max-width: 450px){
.kovatek-login{
  width:100%;
} 
}
</style>